// Pure date arithmetic (no formatting — see lib/format/date.js for that).
import { addDays, differenceInCalendarDays, format, parseISO, isValid } from 'date-fns';

// Calendar days from today to `date`; null once the date is missing or unparseable.
export const daysUntil = (date) => {
  if (!date) return null;
  const target = typeof date === 'string' ? parseISO(date) : date;
  return isValid(target) ? differenceInCalendarDays(target, new Date()) : null;
};

// A `yyyy-MM-dd` date-input value moved by whole days; '' when it can't be read.
export const shiftDateInput = (value, days) => {
  const date = value ? parseISO(value) : null;
  return date && isValid(date) ? format(addDays(date, days), 'yyyy-MM-dd') : '';
};
